import { useCallback, useRef } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
function useComposedSortPersist() {
    const { set, toolbarActiveButton, onSortPersistStart, onSortPersistSuccess, onSortPersistError } = useFolderTree();
    const sortPersistRef = useRef({
        onSortPersistStart,
        onSortPersistSuccess,
        onSortPersistError
    });
    sortPersistRef.current = {
        onSortPersistStart,
        onSortPersistSuccess,
        onSortPersistError
    };
    return useCallback(async (persist)=>{
        set({
            isSortableBusy: true,
            isToolbarBusy: true,
            isCreatableLinkDisabled: true,
            isSortableDisabled: false
        });
        const hide = sortPersistRef.current.onSortPersistStart?.();
        try {
            const result = await persist();
            if (result !== false) {
                sortPersistRef.current.onSortPersistSuccess?.();
            }
            return result;
        } catch (error) {
            sortPersistRef.current.onSortPersistError?.(error);
            throw error;
        } finally{
            hide?.();
            set({
                isSortableBusy: false,
                isToolbarBusy: false,
                isCreatableLinkDisabled: !!toolbarActiveButton,
                isSortableDisabled: !toolbarActiveButton,
                toolbarActiveButton
            });
        }
    }, [
        set,
        toolbarActiveButton
    ]);
}
export { useComposedSortPersist };
